import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { jsx as _jsx } from "react/jsx-runtime";
const basePillProps = {
  paddingInline: '100',
  minInlineSize: '24px',
  blockSize: '18px',
  borderRadius: 'full',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
const CitationPill = ({
  label,
  onClick,
  onMouseEnter,
  onMouseLeave,
  disabled,
  variant = 'default'
}) => {
  const renderedPill = variant === 'outlined' ? /*#__PURE__*/_jsx(Flex, Object.assign({}, basePillProps, {
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderWidth: "100",
    borderStyle: "solid",
    children: /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "detail-200",
      color: "text-core-subtle",
      children: label
    })
  })) : /*#__PURE__*/_jsx(Flex, Object.assign({}, basePillProps, {
    backgroundColor: "fill-primary-disabled",
    children: /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "detail-100",
      color: "text-core-subtle",
      children: label
    })
  }));
  return /*#__PURE__*/_jsx(Clickable, {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    disabled: disabled,
    inlineSize: "fit-content",
    display: "inline-block",
    cursor: disabled ? 'not-allowed' : 'pointer',
    children: renderedPill
  });
};
CitationPill.displayName = 'CitationPill';
export default CitationPill;